// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconClock = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 32C8 46.809 17.191 56 32 56C46.809 56 56 46.809 56 32C56 17.191 46.809 8 32 8C17.191 8 8 17.191 8 32ZM19.8246 35.6979L29.9326 30.7866L29.088 15.5832C29.0346 14.6226 29.6235 14 30.5856 14H33.4144C34.3765 14 34.9654 14.6226 34.912 15.5832L34.0215 31.6118C33.9635 32.657 33.5745 33.3433 32.7075 33.93L22.7099 40.6953C21.9044 41.2403 21.0565 41.0452 20.5702 40.2029L19.1812 37.7971C18.6949 36.9548 18.9499 36.1229 19.8246 35.6979Z" />
    </svg>
  );
};
